var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.763 6.233c.31.31.31.815 0 1.125L13.125 12l4.642 4.638a.797.797 0 0 1-1.125 1.125L12 13.125l-4.638 4.642a.797.797 0 0 1-1.125-1.125L10.874 12 6.233 7.362a.797.797 0 0 1 1.126-1.125L12 10.874l4.638-4.641a.797.797 0 0 1 1.125 0Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlackIcon);
export default __webpack_public_path__ + "static/media/close-black-icon.24a38ca83f0be844b1bdbbab29a0fed7.svg";
export { ForwardRef as ReactComponent };